import React from 'react';
import { useNavigate } from 'react-router-dom';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Lock } from '@mui/icons-material';
import './usr_dashboard_ux.css';
import PropTypes from 'prop-types';

// # Carousel component for dashboard sections
const UserDashboardUX = ({ sections, isDarkMode }) => {
  const navigate = useNavigate();

  // # Get slider settings based on number of items
  const getSliderSettings = (itemCount) => {
    const baseSettings = {
      dots: true,
      infinite: itemCount > 3,
      speed: 500,
      autoplay: itemCount > 3,
      autoplaySpeed: 3000,
      pauseOnHover: true,
      slidesToShow: Math.min(3, itemCount),
      slidesToScroll: 1,
      centerMode: false,
      centerPadding: '0',
      lazyLoad: 'ondemand',
      swipeToSlide: true,
      touchThreshold: 8,
      useCSS: true,
      useTransform: true,
      rows: 1,
      slidesPerRow: 1,
      adaptiveHeight: true,
      variableWidth: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: Math.min(2, itemCount),
            slidesToScroll: 1,
            infinite: itemCount > 2,
            dots: true,
            centerMode: false,
            adaptiveHeight: true,
            arrows: itemCount > 1,
            speed: 400
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: itemCount > 1,
            dots: true,
            centerMode: false,
            adaptiveHeight: true,
            swipeToSlide: true,
            touchThreshold: 5,
            arrows: itemCount > 1,
            speed: 350,
            variableWidth: false
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: itemCount > 1,
            dots: true,
            centerMode: false,
            arrows: false,
            swipeToSlide: true,
            touchThreshold: 5,
            speed: 300,
            adaptiveHeight: true,
            variableWidth: false
          }
        }
      ]
    };

    return baseSettings;
  };

  // # Handle item click
  const handleItemClick = (path) => {
    navigate(path);
  };

  return (
    <div className={`usr_ux-sections ${isDarkMode ? 'usr_ux-dark-mode' : ''}`}>
      {Object.entries(sections).map(([key, section]) => (
        <div key={key} className="usr_ux-section usr_ux-animate-slide">
          <h3 className="usr_ux-section-title">{section.title}</h3>
          <div className={`usr_ux-carousel-container ${section.items.length <= 2 ? 'usr_ux-fixed-carousel' : ''}`}>
            <Slider {...getSliderSettings(section.items.length)}>
              {section.items.map((item, index) => (
                <div 
                  key={`${key}-${index}`}
                  className="usr_ux-carousel-item-wrapper"
                >
                  <div 
                    className={`usr_ux-carousel-item usr_ux-animate-fade ${item.locked ? 'usr_ux-item-locked' : ''}`}
                    onClick={() => handleItemClick(item.path)}
                  >
                    <div className="usr_ux-item-content">
                      <div className="usr_ux-item-icon">
                        <img src={item.icon} alt={item.title} />
                        {item.locked && (
                          <div className="usr_ux-lock-overlay">
                            <Lock className="usr_ux-lock-icon" />
                          </div>
                        )}
                      </div>
                      <h4 className="usr_ux-item-title">{item.title}</h4>
                      <p className="usr_ux-item-description">{item.description}</p>
                      {item.locked && (
                        <button className="usr_ux-subscribe-button">
                          Subscribe Now
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      ))}
    </div>
  );
};

UserDashboardUX.propTypes = {
  sections: PropTypes.object.isRequired,
  isDarkMode: PropTypes.bool
};

export default UserDashboardUX;
